import React, { FC } from 'react';
import { SystemRoutes, UserRoutes, MainNavRoutes } from './partials';

const Routes: FC = (): JSX.Element => {
	return (
		<>
			<SystemRoutes />
			<UserRoutes />
			<MainNavRoutes />
		</>
	);
};

export { Routes };
